import { atom } from "jotai";
import { WebSocketEventHandler, WebSocketEventType } from "@/model";

export const socketEventHandlersAtom = atom<Record<WebSocketEventType, WebSocketEventHandler[]>>({
    background_job_status: [],
    background_job_ended: [],
    agent_summary: []
});

